export default "__VITE_ASSET__qpREe5cE__"